import axios from './axiosConfig';
import { AxiosPromise } from 'axios';
import { IUserTransactionHistory, IUserTransactionHistoryParams } from '../models/userTransactionHistory.model';

export const getUserTransactionHistoryList = (params: IUserTransactionHistoryParams): AxiosPromise<IUserTransactionHistory[]> => axios.get(`/api/user-transaction-history`, { params });
